import { base58 } from "@scure/base";

//#region src/b58.ts
const toBase58 = (buffer) => base58.encode(buffer);
const fromBase58 = (str) => base58.decode(str);

//#endregion
export { fromBase58, toBase58 };
//# sourceMappingURL=b58.mjs.map